// Mapping of user-facing regions to Riot API regions
export const REGION_GROUPS = {
  Americas: ['North America', 'Brazil', 'LAS', 'LAN'],
  Asia: ['Korea', 'Japan', 'Southeast Asia', 'Taiwan', 'Vietnam'],
  Europe: ['Europe West', 'Europe Nordic & East', 'Russia', 'Türkiye'],
  ESports: ['Middle East']
};

// Mapping of display names to Riot region codes
export const REGION_CODES = {
  'North America': 'americas',
  'Middle East': 'europe',
  'Europe West': 'europe',
  'Europe Nordic & East': 'europe',
  'Oceania': 'americas',
  'Korea': 'asia',
  'Japan': 'asia',
  'Brazil': 'americas',
  'LAS': 'americas',
  'LAN': 'americas',
  'Russia': 'europe',
  'Türkiye': 'europe',
  'Southeast Asia': 'asia',
  'Taiwan': 'asia',
  'Vietnam': 'asia'
};

// Icons for each region (using flag emojis where appropriate)
export const REGION_ICONS = {
  'North America': '🌎',
  'Middle East': '🌍',
  'Europe West': '🇪🇺',
  'Europe Nordic & East': '🇪🇺',
  'Oceania': '🌏',
  'Korea': '🇰🇷',
  'Japan': '🇯🇵',
  'Brazil': '🇧🇷',
  'LAS': '🌎',
  'LAN': '🌎',
  'Russia': '🇷🇺',
  'Türkiye': '🇹🇷',
  'Southeast Asia': '🌏',
  'Taiwan': '🇹🇼',
  'Vietnam': '🇻🇳'
};
